// App.tsx ou em um componente de nível superior

import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { setLocalStorageItem } from "presentation/utils/localStorage";

const RouteTracker: React.FC<React.PropsWithChildren> = ({ children }) => {
  const location = useLocation();
  useEffect(() => {
    // Salva a rota atual no localStorage sempre que ela muda
    setLocalStorageItem("lastRoute", location.pathname + location.search);
  }, [location]);
  return <>{children}</>;
};

export default RouteTracker;
